const featureNL = {
    "view": {
        "table": {
            "title": "Functie Verzoeken",
            "column": {
                "release_name": "Naam",
                "release_artist_name": "Artiest Naam",
                "release_date": "Uitgavedatum",
                "exclusive_date": "Exclusieve Datum"
            },
            "button": {
                "export_csv": "Exporteer CSV"
            },
            "placeholder": {
                "search": "Zoeken..."
            }
        },
        "message": {
            "subscriptionUpgrade": "Uw huidige abonnementsplan ondersteunt deze functie niet. Gelieve uw abonnementsplan te <1>upgraden</1> om deze functie te gebruiken.",
            "subscriptionExpired": "Uw abonnement is verlopen. Gelieve uw abonnement te <1>hervatten</1> om deze functie te gebruiken.",
            "noAccess": "U heeft geen toegang tot deze module, neem contact op met het ondersteuningsteam voor meer informatie."
        }
    },
    "add": {
        "title": "Marketing Feiten",
        "form": {
            "label": {
                "release": "Release",
                "djTastemaker": "DJ / TasteMaker feedback:",
                "radioSupport": "Radio ondersteuning",
                "marketingPR": "Marketing / PR",
                "labelReach": "Label en artiesten bereik:"
            },
            "help_text": {
                "release": "Selecteer een release waarvoor u een functieverzoek wilt indienen. U kunt alleen releases zien en selecteren die een algemene releasedatum hebben van 22 dagen of meer vooruit. Als u mikt op een exclusieve releasedatum pitch, zorg er dan voor dat u dit formulier ten minste 22 dagen voor een (eerste) exclusieve releasedatum indient.",
                "djTastemaker": "Voer 10 DJ / Radio / Magazine feedbacks in het formaat 'Naam - Feedback' in (Voer elke feedback op een nieuwe regel in). Inzendingen met 'downloading for' worden niet gepromoot of naar online winkels gestuurd.",
                "radioSupport": "Is uw nummer of release te horen op sommige radiostations? Zo ja, noem het station en voeg de bijbehorende link naar hun pagina toe waar zichtbaar is dat ze uw nummers promoten of afspelen.",
                "marketingPR": "(Interviews, blogs, recensies, tijdschriftartikelen) - Gelieve alle toegezegde pers- en marketingactiviteiten voor deze release op te sommen. Niet verplicht maar essentieel om op te vallen in de concurrentie.",
                "labelReach": "Het gecombineerde (label en artiesten) aantal volgers op Facebook, Instagram, SoundCloud en YouTube. <strong>Gelieve elk platform en aantal volgers op een nieuwe regel te zetten</strong>."
            },
            "button": {
                "submit": "Indienen"
            },
            "message": {
                "releaseRequired": "Bestaande release is vereist",
                "featureRequestAlreadyExists": "Functieverzoek voor deze release is al gedaan"
            }
        },
        "message": {
            "success": "Functieverzoek is toegevoegd!",
            "error": "Er is iets misgegaan! Ververs de pagina en probeer het opnieuw!"
        },
        "modal": {
            "confirm": {
                "header": "Nieuw functieverzoek",
                "body": "Dit functieverzoek moet ten minste 21 dagen voor de eerste (exclusieve of algemene, wat het eerst komt) datum worden ingediend. Helaas kunnen late inzendingen niet in overweging worden genomen. Wilt u uw functieverzoek indienen?"
            }
        }
    }
};

export default featureNL;